import { isEn } from "i18next-config";
import ChartSeriesDto from "./ChartSeriesDto";

export class ChartsDto {
  static fromApi(data) {
    const {
      active: isActive,
      default: isDefault,
      editable: isEditable,
      visible: isVisible,
      title,
      indices,
      id,
      ...rest
    } = data;

    const series = ChartSeriesDto.fromApiArray(indices);

    return {
      ...rest,
      id: id?.toString(),
      isActive,
      isDefault,
      isEditable,
      isVisible,
      series,
      title: isEn ? data.title.en : data.title.el,
      titleLocales: title,
    };
  }
  static fromApiArray(data) {
    return [...data.defaultChart, ...data.customChart]
      .map(ChartsDto.fromApi)
      .sort((a, b) => (a.order === b.order ? 1 : a.order - b.order));
  }

  static toApi(data) {
    const { title, series: dataSeries, fieldId } = data;
    const series = ChartSeriesDto.toApiArray(dataSeries);

    return {
      // id: rest.id,
      // deviceType: rest.deviceType,
      // extra: rest.extra,
      // order: rest.order,
      // type: rest.type,
      fieldId,
      title: {
        en: title,
        el: title,
      },
      // active: isActive,
      // default: isDefault,
      // editable: isEditable,
      // visible: isVisible,
      series,
    };
  }
}
